module.exports = __webpack_public_path__ + "img/winner-page-heti.b963cd5d.png";